<template>
    <el-dialog title="供应商消息" :visible.sync="dialogVisible" width="960px">
        <el-table height="500" border :data="tableData">
            <el-table-column
                label="序号"
                type="index"
                align="center"
                width="60"
            >
            </el-table-column>
            <el-table-column prop="content" label="内容" :show-overflow-tooltip="true"></el-table-column>
        </el-table>
    </el-dialog>
</template>
<script>
export default {
    computed: {},
    data() {
        return {
            dialogVisible: false,
            tableData: []
        };
    },
    methods: {
        open(data) {
            this.dialogVisible = true;
            this.tableData = data;
        }
    },
};
</script>
